import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button8Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M0.503448 9.88333L0.768616 3.78455L6.16031 9.17622L8.98874 6.34781L3.59705 0.956116L9.69585 0.690948L13.3043 4.29938C14.051 6.04515 14.0551 8.03273 13.3167 9.78119L18.6673 15.1317C19.6436 16.108 19.6436 17.6909 18.6673 18.6673C17.6909 19.6436 16.108 19.6436 15.1317 18.6673L9.85289 13.3884C8.04366 14.2411 5.94453 14.2756 4.11188 13.4918L0.503448 9.88333Z" />
  </SvgIcon>
);

export default PO28Button8Icon;
